import React from 'react'
import { FormFieldProps } from './types'

function FormField({
  name,
  label,
  required = false,
  error,
  helpText,
  className = '',
  disabled = false,
  children
}: FormFieldProps): JSX.Element {
  const fieldId = `field-${name}`
  
  return (
    <div className={`tw-flex tw-flex-col tw-gap-2 ${className}`}>
      {label && (
        <label
          htmlFor={fieldId}
          className="tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-200"
        >
          {label}
          {required && (
            <span className="tw-text-red-500 tw-ml-1" aria-label="Required">
              *
            </span>
          )}
        </label>
      )}
      
      <div className="tw-relative">
        {React.isValidElement(children) 
          ? React.cloneElement(children, {
              id: fieldId,
              name,
              disabled,
              'aria-invalid': error ? 'true' : 'false',
              'aria-describedby': `${fieldId}-${error ? 'error' : 'help'}`
            })
          : children
        }
      </div>
      
      {error && (
        <div
          id={`${fieldId}-error`}
          className="tw-text-sm tw-text-red-600 dark:tw-text-red-400"
          role="alert"
        >
          {error}
        </div>
      )}
      
      {helpText && !error && (
        <div
          id={`${fieldId}-help`}
          className="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400"
        >
          {helpText}
        </div>
      )}
    </div>
  )
}

export default FormField